import type { Variants } from 'framer-motion';

import { transitionExit, transitionEnter } from './transition';

import type { VariantsTransitionOptions } from './transition';

// ----------------------------------------------------------------------

export type RotateDirection = 'in' | 'out';

export type RotateOptions = VariantsTransitionOptions & { deg?: number };

export const varRotate = (direction: RotateDirection, options?: RotateOptions): Variants => {
  const deg = options?.deg || 360;
  const transitionIn = options?.transitionIn;
  const transitionOut = options?.transitionOut;

  const variants: Record<RotateDirection, Variants> = {
    /**** In ****/
    in: {
      initial: { opacity: 0, rotate: -deg },
      animate: { opacity: 1, rotate: 0, transition: transitionEnter(transitionIn) },
      exit: { opacity: 0, rotate: -deg, transition: transitionExit(transitionOut) },
    },
    /**** Out ****/
    out: {
      initial: { opacity: 1, rotate: 0 },
      animate: { opacity: 0, rotate: -deg, transition: transitionExit(transitionOut) },
    },
  };

  return variants[direction];
};
